export default {
   /* eslint-disable key-spacing */
   '01': 'Mikro',
   '02': 'Kecil',
   '03': 'Menengah',
   '04': 'Besar',
   /* eslint-enable key-spacing */
}
